<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <layout :titlePage="titlePage" :route="{ name: 'carteira' }">
    <section class="c-receipt">
      <div class="columns columns--full is-vcentered is-gapless">
        <div class="column is-two-fifths">
          <base-header-page
            :class="{ 'has-background-error': error }"
            class="c-base-header-page--full has-text-white has-background-success"
          >
            <base-icon
              :name="headerIcon"
              class="c-receipt__header-icon"
              width="50"
              height="50"
            />
            <p>
              <strong class="has-text-white is-size-6 is-size-5-tablet">
                <div v-html="title"></div>
              </strong>
            </p>
          </base-header-page>
        </div>
        <div class="column">
          <div class="c-receipt__wrapper has-text-centered">
            <BaseReceiptError v-if="error" :reason="errorReason" />
            <TransactionPixReceiptSuccess
              v-else-if="
                transaction && transaction.reference_id === 'starkbank'
              "
              :transaction="transaction"
            />
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import layout from '@/layouts/Default.vue'
import BaseHeaderPage from '@/components/BaseHeaderPage.vue'
import TransactionPixReceiptSuccess from '@/components/Wallet/TransactionPixReceiptSuccess.vue'
import BaseReceiptError from '@/components/Wallet/BaseReceiptError.vue'

import WalletApi from '@/lib/api/Wallet'

export default {
  components: {
    layout,
    BaseHeaderPage,
    TransactionPixReceiptSuccess,
    BaseReceiptError,
  },

  metaInfo: {
    title: 'Comprovante de solicitação de transferência',
  },

  computed: {
    lastDraw: {
      get() {
        return this.$store.state.wallet.lastDraw
      },
      set(payload) {
        this.$store.dispatch('setLastDraw', payload)
      },
    },

    title() {
      return this.error
        ? 'Houve um problema ao tentar<br>concluir essa solicitação.'
        : 'Solicitação concluída<br> com sucesso!'
    },

    headerIcon() {
      return this.error
        ? 'painel/close-circle-icon'
        : 'painel/check-circle-icon'
    },

    titlePage() {
      return 'Transferência por PIX'
    },

    logonToken() {
      return this.$store.state.app.logonToken
    },

    walletSummary: {
      get() {
        return this.$store.state.wallet.walletSummary
      },
      set(payload) {
        this.$store.dispatch('setWalletSummary', payload)
      },
    },

    walletUpdatedAt: {
      get() {
        return this.$store.state.wallet.walletUpdatedAt
      },
      set(payload) {
        this.$store.dispatch('setWalletUpdatedAt', payload)
      },
    },

    walletSurveys() {
      return this.$store.getters.walletSurveys
    },

    wedSiteInfo() {
      return this.$store.state.app.wedSiteInfo
    },

    transactions: {
      get() {
        return this.$store.state.wallet.transactions
      },
      set(payload) {
        this.$store.dispatch('setTransactions', payload)
      },
    },

    transactionsMeta: {
      get() {
        return this.$store.state.wallet.transactionsMeta
      },
      set(payload) {
        this.$store.dispatch('setTransactionsMeta', payload)
      },
    },
  },

  data() {
    return {
      error: false,
      errorReason: '',
      transaction: null,
      balance: '',
    }
  },

  async created() {
    if (this.lastDraw.type === 'transaction') {
      this.transaction = this.lastDraw
      this.updateWallet()
    }

    // balance - withdraw
    this.balance = this.walletSummary.balance - this.$route.params.value

    if (!this.lastDraw && !this.lastDraw.type)
      this.$router.push({ name: 'carteira' })
    else this.setData()
  },

  methods: {
    surveyPresented() {
      if (!this.walletSurveys.withdraw_presented_at) {
        const walletApi = new WalletApi(this.logonToken)
        walletApi
          .setSurveyPresented()
          .catch(console.warn('Set Survey presented failed'))
          .finally(() => {})
      }
    },

    surveyAfterShoppingOrderPresented() {
      if (!this.walletSurveys.withdraw_after_shopping_order_presented_at) {
        const walletApi = new WalletApi(this.logonToken)
        walletApi
          .setSurveyAfterShoppingOrderPresented()
          .catch(console.warn('Set Survey presented failed'))
          .finally(() => {})
      }
    },

    setData() {
      if (this.lastDraw.type === 'transaction') {
        // Show Survey only if user has shopping and not answered it before( Buyers)
        if (
          !this.walletSurveys.withdraw_after_shopping_order_presented_at &&
          this.walletSummary.balance_shopping > 0 // withdraw using pix
        ) {
          this.surveyAfterShoppingOrderPresented()
        } else if (
          // (not answered it before (Non Buyers))
          !this.walletSurveys.withdraw_after_shopping_order_presented_at &&
          !this.walletSurveys.withdraw_presented_at //withdraw using pix
        ) {
          this.surveyPresented()
        }
      } else if (this.lastDraw.type === 'error') {
        this.errorReason = this.lastDraw.reason
        this.error = true
      } else return this.$router.push({ name: 'carteira' })
      this.lastDraw = {}
    },

    updateWallet() {
      const walletApi = new WalletApi(this.logonToken)

      walletApi.getTransactions().then((response) => {
        const transactions = response?.data
        if (transactions) {
          this.transactions = transactions.data
          this.transactionsMeta = transactions.meta
        }
      })

      walletApi.getSummary().then((walletSummary) => {
        this.walletSummary = walletSummary
        this.walletUpdatedAt = new Date()
      })
    },
  },
}
</script>

<style lang="scss">
.c-receipt {
  &__header-icon {
    @media (min-width: $tablet) {
      width: 110px;
      height: 110px;
    }
  }

  &__wrapper {
    padding: 2em 12px 0;
    margin: 0 auto;
    max-width: 420px;
  }

  .c-base-summary {
    margin: 2em auto;

    &__wrapper {
      padding: 18px 0;
      margin: 0 auto;
      max-width: 320px;
    }

    &__content-bordered {
      position: relative;
      &:before {
        content: '';
        @include position(absolute, auto, 0, -6px, auto);
        width: 100px;
        height: 1px;
        background-color: $gray-3;
      }
    }
  }
}
</style>
